import { memo, type ReactElement } from 'react'

interface CustomersListIconProps {
  active: boolean
}

function CustomersListIcon ({ active }: CustomersListIconProps): ReactElement {
  return (

    <svg fill={active ? '#FFF' : '#7F95A0'} xmlns="http://www.w3.org/2000/svg" height="2em" viewBox="0 0 512 512">
      <path
        d="M391.9 391.6L368 320H144l-23.9 71.6C154.9 426.5 202.9 448 256 448s101.1-21.5 135.9-56.4zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"
      />
    </svg>
  )
}

export default memo(CustomersListIcon)
